import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
// import { PostHogProvider } from "posthog-js/react";
import { MsalProvider } from "@azure/msal-react";

import msalInstance from "./authConfig";
import installFetchAuth from "./utils/fetchWithMsal";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import posthog from "posthog-js";

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  capture_exceptions: true,
});
// posthog.sessionRecording._forceAllowLocalhostNetworkCapture = true;
// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <RouterProvider router={router} />
      </MsalProvider>
    </StrictMode>,
  );
  // Install global fetch auth wrapper (adds Authorization header for backend requests)
  try { installFetchAuth(); } catch (e) {}
}
